import { useFormContext, Controller } from 'react-hook-form';
import {
  RadioGroup,
  RadioGroupProps,
  Radio,
  FormControlLabel,
  RadioProps,
} from 'material-hu';

type Props = RadioGroupProps & {
  options: { value: any; label: string }[];
  radioProps?: RadioProps;
  rules?: any;
  defaultValue?: string;
  disabled?: boolean;
  onChangeSkipStep?: (param) => void;
  indexAsValue?: boolean;
  valueAsNumber?: boolean;
};

function FormRadioGroup({
  name,
  options,
  radioProps,
  rules,
  defaultValue,
  disabled,
  onChangeSkipStep = () => null,
  indexAsValue = false,
  valueAsNumber,
  ...other
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      rules={rules}
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, ...field } }) => (
        <RadioGroup
          {...other}
          {...field}
          onChange={(event, value) => {
            onChange(valueAsNumber ? Number(value) : value);
            onChangeSkipStep(event);
          }}
        >
          {options.map((option, index) => (
            <FormControlLabel
              disabled={disabled}
              key={option.value}
              control={
                <Radio
                  sx={{ ml: 1 }}
                  {...radioProps}
                />
              }
              label={option.label}
              value={indexAsValue ? index : option.value}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
}

export default FormRadioGroup;
